import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import GroupElements from 'components/GroupElements';
import Tag from 'components/Tag';
import { useTabNavigation } from 'hooks/useTabNavigation';

const TagList = ({ tags }) => {
	const {
		firstListItemRef,
		handleBlur,
		handleFocus,
		handleKeyDown,
		listItemTabIndex
	} = useTabNavigation();

	return (
		<Container width="narrow">
			<GroupElements
				aria-label="Список тегов"
				tabIndex={0}
				onKeyDown={handleKeyDown}
				onFocus={handleFocus}
				onBlur={handleBlur}
				role="toolbar"
			>
				{tags.map((tag, index) => (
					<Tag
						key={tag.url}
						title={tag.title}
						url={tag.url}
						textTheme="light"
						theme="bordered"
						tabIndex={listItemTabIndex}
						ref={index === 0 ? firstListItemRef : null}
					/>
				))}
			</GroupElements>
		</Container>
	);
};

TagList.propTypes = {
	tags: PropTypes.array
};

export default TagList;
